// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2dpx6","choiceBoxes":"toolbarselects_choiceBoxes__3u2we","simpleField":"toolbarselects_simpleField__2X5hI"};